export const environment = {
  production: false,
  brands: {
    enelx: {
      baseUrl: 'https://ops-stream.dev-apps.enelx.net/v1/api',
      globalNavUrl: 'https://global-nav.dev-svcs.enelx.net/api/v1',
    },
  },
  cdn: 'https://cdn.dev-apps.enelx.net',
  defaults: {
    brand: 'enelx',
    locale: 'en-us',
    apiLocale: 'en_US',
  },
};
